import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {conceptOrderLoadActionTypes, LoadSuccessConceptOrderAction} from '../actions/order-dxp-concept-load';

export interface ConceptsOrderState {
  // tslint:disable-next-line:no-any
  array: any[];
}

const initialState: ConceptsOrderState = {
  array: undefined
};

export function ConceptsOrderReducer(state: ConceptsOrderState = initialState, action: Action): ConceptsOrderState {
  switch (action.type) {
    case conceptOrderLoadActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case conceptOrderLoadActionTypes.LOAD_FAIL:
    case conceptOrderLoadActionTypes.CLEAR:
      return handleLoadErrorActions(state);
    default:
      return state;
  }
}


function handleLoadSuccessAction(state: ConceptsOrderState, action: LoadSuccessConceptOrderAction): ConceptsOrderState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleLoadErrorActions(state: ConceptsOrderState): ConceptsOrderState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}


export const conceptsOrderSelectors = {
  array: (state: ConceptsOrderState) => _.get(state, 'array', [])
};
